export class ItemType {
  id: number;
  name: string;
}
